import TextField from '~/presentation/workflow/detail/editor/form/inputWidget/render/EntityField/EntityField'

export default TextField
